module.exports = __webpack_public_path__ + "img/heading_uk.fc9baca9.svg";